// reducer.js
import { FETCH_KEY_KNOW_REQUEST, FETCH_KEY_KNOW_SUCCESS, FETCH_KEY_KNOW_FAILURE } from '../../actions';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const keyKnowReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KEY_KNOW_REQUEST:
      return { ...state, loading: true };
    case FETCH_KEY_KNOW_SUCCESS:
      return { loading: false, data: action.payload, error: '' };
    case FETCH_KEY_KNOW_FAILURE:
      return { loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default keyKnowReducer;
